import clsx from "clsx";
import React from "react";
import { MarkupText } from "./MarkupText";
export function ParagraphText(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx({
            "pb-0": !props.text
        }, "paragraph-container container-page")
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx({
            "container-content": !props.isNested
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("container-text", props.className)
    }, props.title && /*#__PURE__*/ React.createElement(React.Fragment, null, !props.isNested ? /*#__PURE__*/ React.createElement("h2", {
        className: clsx({
            "mb-0": !props.text
        })
    }, props.title) : /*#__PURE__*/ React.createElement("h3", null, props.title)), /*#__PURE__*/ React.createElement("div", null, props.text && /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.text,
        classNames: props.markeupClassNames,
        tableVariant: !props.isNested ? "full" : "nested"
    })))));
}
